import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  getJobSeekerDashboardSummary,
  getJobSeekerApplications,
  getRecentJobSeekerApplications,
  getSuggestedJobs,
  getProfileCompletion,
  getResumes,
  getInterviewSchedule,
} from "../api/jobSeekerAPI/jobSeekerDashboardApi";



const JobSeekerDashboard = () => {
  const token = localStorage.getItem("otoken");
  const seeker_id = localStorage.getItem("aUId");

  const [stats, setStats] = useState({
    appliedJobs: 0,
    interviewCalls: 0,
    shortlisted: 0,
    interviewScheduled: 0,
  });

  const [applications, setApplications] = useState([]);
  const [recentApplications, setRecentApplications] = useState([]);
  const [suggestedJobs, setSuggestedJobs] = useState([]);
  const [profileCompletion, setProfileCompletion] = useState(0);
  const [resumes, setResumes] = useState([]);
  const [interviews, setInterviews] = useState([]);

 useEffect(() => {
  if (!token || !seeker_id) return;

  const loadDashboard = async () => {
    setStats(await getJobSeekerDashboardSummary(token, seeker_id));
    setApplications(await getJobSeekerApplications(token, seeker_id));
    setRecentApplications(await getRecentJobSeekerApplications(token, seeker_id));
    setSuggestedJobs(await getSuggestedJobs(token, seeker_id));
    // setProfileCompletion(
    //   (await getProfileCompletion(token, seeker_id))?.completionPercentage || 0
    // );
    setResumes(await getResumes(token, seeker_id));
    setInterviews(await getInterviewSchedule(token, seeker_id));
  };

  loadDashboard();
}, [token, seeker_id]);




  return (

        <div className="content-body">

            <div className="container-fluid mt-3">
                <div className="row">
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-1">
                            <div className="card-body">
                                <h3 className="card-title text-white">Applied Jobs</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.appliedJobs}</h2>
                                    {/* <p className="text-white mb-0">Jan - March 2019</p> */}
                                </div>
                                {/* <span className="float-right display-5 opacity-5"><i className="fa fa-shopping-cart"></i></span> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-2">
                            <div className="card-body">
                                <h3 className="card-title text-white">Interview Calls</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.interviewCalls}</h2>
                                    {/* <p className="text-white mb-0">Jan - March 2019</p> */}
                                </div>
                                {/* <span className="float-right display-5 opacity-5"><i className="fa fa-money"></i></span> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-3">
                            <div className="card-body">
                                <h3 className="card-title text-white">Shortlisted</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.shortlisted}</h2>
                                    {/* <p className="text-white mb-0">Jan - March 2019</p> */}
                                </div>
                                {/* <span className="float-right display-5 opacity-5"><i className="fa fa-users"></i></span> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="card gradient-4">
                            <div className="card-body">
                                <h3 className="card-title text-white">Interview Scheduled</h3>
                                <div className="d-inline-block">
                                    <h2 className="text-white">{stats.interviewScheduled}</h2>
                                    {/* <p className="text-white mb-0">Jan - March 2019</p> */}
                                </div>
                                {/* <span className="float-right display-5 opacity-5"><i className="fa fa-heart"></i></span> */}
                            </div>
                        </div>
                    </div>
                </div>

               

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                
                                 <h3 className="card-title">My Job Applications</h3>
                                <div className="active-member">
                                    <div className="table-responsive">
                                        <table className="table table-xs mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Position</th>
                                                    <th>Company</th>
                                                    <th>Status</th>
                                                    <th>Applied On</th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {applications.map((app) => (
                                                    <tr key={app.application_id}>
                                                    <td>{app.position}</td>
                                                    <td>{app.company_name}</td>
                                                    <td>
                                                        <span className={`badge bg-${app.status === "Shortlisted" ? "success" : "warning"}`}>
                                                        {app.status}
                                                        </span>
                                                    </td>
                                                    <td>{new Date(app.appliedOn).toLocaleDateString()}</td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="card shadow">
                            <div className="card-header">Recent Applications</div>
                            <div className="card-body">
                            <ul className="list-group">
                                {recentApplications.map((app, i) => (
                                    <li key={i} className="list-group-item d-flex justify-content-between">
                                    {app.title} - {app.company_name}
                                    <span className="badge bg-secondary">{app.status}</span>
                                    </li>
                                ))}
                            </ul>
                            </div>
                        </div>
                        </div>
                    <div className="col-xl-6 col-lg-6 col-sm-6 col-xxl-6">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Suggested Jobs</h4>
                                <div id="activity">
                                    {suggestedJobs.map((job) => (
                                        <div key={job.job_id} className="media border-bottom-1 pt-3 pb-3">
                                            <div className="media-body">
                                            {job.title} - {job.company_name}
                                            </div>
                                            {/* <button className="btn btn-outline-primary btn-sm">Apply</button> */}
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
    {/* <div className="col-md-6">
      <div className="card shadow">
        <div className="card-header">Application Status Tracker</div>
        <div className="card-body">
          <div className="mb-2">Overall Progress</div>
          <div className="progress" style={{height: '16px;'}}>
            <div className="progress-bar bg-success" style={{width: '60%;'}}>60%</div>
          </div>
        </div>
      </div>
    </div> */}

    
    {/* <div className="col-md-6">
      <div className="card shadow">
        <div className="card-header">Profile Completion</div>
        <div className="card-body">
          <div className="mb-2">Complete your resume and add your skills!</div>
          <div className="progress" style={{height: '16px;'}}>
            <div className="progress-bar bg-info" style={{ width: `${profileCompletion}%` }}>
                {profileCompletion}%
            </div>

          </div>
        </div>
      </div>
    </div> */}

   
    {/* <div className="col-md-6">
      <div className="card shadow">
        <div className="card-header">Resume Manager</div>
        <div className="card-body">
         <ul className="list-group">
            {resumes.map((r) => (
                <li key={r.document_id} className="list-group-item d-flex justify-content-between">
                {r.document_name}
                <a href={r.document_url} className="btn btn-sm btn-secondary">Download</a>
                </li>
            ))}
        </ul>

          <button className="btn btn-primary btn-sm mt-3">Upload New Document</button>
        </div>
      </div>
    </div> */}

   
    {/* <div className="col-md-6">
      <div className="card shadow">
        <div className="card-header">Interview Schedule</div>
        <div className="card-body">
        <ul className="list-group">
            {interviews.map((i) => (
                <li key={i.interview_id} className="list-group-item">
                {new Date(i.scheduled_at).toLocaleString()} – {i.title} ({i.company_name})
                </li>
            ))}
        </ul>

        </div>
      </div>
    </div> */}
                </div>
            </div>
           
        </div>
      
  );
};
export default JobSeekerDashboard;
